import { SocialButtonType } from '../interfaces/socialButton'
import { ISocialPlatform } from '../../interfaces/socials'

export const getSocialUserUrl = (
  platform: SocialButtonType | ISocialPlatform,
  username: string
) => {
  const lowerUsername = username?.toLowerCase() ?? ''
  switch (platform) {
    case SocialButtonType.FACEBOOK:
      return `https://www.facebook.com/${lowerUsername}`
    case SocialButtonType.TWITTER:
      return `https://twitter.com/${lowerUsername}`
    case SocialButtonType.INSTAGRAM:
    case SocialButtonType.INSTAGRAM_BASIC:
      return `https://www.instagram.com/${lowerUsername}`
    case SocialButtonType.LINKEDIN:
      return `https://www.linkedin.com/in/${lowerUsername}`
    case SocialButtonType.TIKTOK:
      return `https://www.tiktok.com/@${lowerUsername}`
    case SocialButtonType.YOUTUBE:
      return `https://www.youtube.com/@${lowerUsername}`
    case SocialButtonType.TELEGRAM:
      return `https://telegram.me/${lowerUsername}`
    case SocialButtonType.DISCORD:
      return `https://discord.gg/${lowerUsername}`
    case SocialButtonType.TWITCH:
      return `https://www.twitch.tv/${lowerUsername}`
    case SocialButtonType.PINTEREST:
      return `https://www.pinterest.com/${lowerUsername}`
    case SocialButtonType.SNAPCHAT:
      return `https://www.snapchat.com/add/${lowerUsername}`
    case SocialButtonType.MEDIUM:
      return `https://medium.com/@${lowerUsername}`
    case SocialButtonType.ONLYFANS:
      return `https://onlyfans.com/${lowerUsername}`
    case SocialButtonType.SUBSTACK:
      return `https://${lowerUsername}.substack.com/`
    case SocialButtonType.IMDB:
    case SocialButtonType.BEEHIIV:
      return `${lowerUsername}`
    case SocialButtonType.BEHANCE:
      return `https://behance.com/${lowerUsername}`
    default:
      return ''
  }
}
